import api from './api';
import { apiFormData } from './api';

// Define types for the asset disposal service
export interface AssetDetail {
  id: string;
  name: string;
  asset_name?: string;
  asset_code: string;
  category: string;
  asset_category_detail?: {
    id: string;
    name: string;
  }
  location?: string;
  location_detail? : {
    id: string;
    name: string;
  };
  department?: string;
  department_detail? : {
    id: string;
    name: string;
  }
  custodian?: string;
  purchase_value?: string;
  accumulated_depreciation_value?: string;
  // Use unknown instead of any for better type safety
  [x: string]: unknown;
  custom_fields?: Record<string, any>;
}

export interface DisposalRequest {
  id?: string;
  asset: string;
  assets_detail?: AssetDetail[];
  reason: string;
  disposal_date: string | Date;
  sold_value?: number | null;
  price_difference?: number | null;
  calculated_depreciation_value?: number | null;
  comments?: string;
  status?: string;
  created_at?: string;
  updated_at?: string;
  documents?: DisposalDocument[];
  workflow_status?: {
    steps: {
      name: string;
      status: string;
      updated_at: string;
    }[];
  };
  supporting_documents?: File[];
}

export interface DisposalDocument {
  id?: string;
  disposal_request: string;
  file: File | string;
  filename?: string;
  file_type?: string;
  file_size?: number;
  uploaded_at?: string;
  url?: string;
}

export interface DisposalRequestParams {
  page?: number;
  page_size?: number;
  limit?: number;
  status?: string;
  from_date?: string;
  to_date?: string;
  location?: string;
  department?: string;
  search?: string;
  asset_tag?: string;
  asset_name?: string;
  comments?: string;
  asset_categories?: string;
  locations?: string;
  departments?: string;
  reasons?: string;
  requested_bys?: string;
  statuses?: string;
  disposal_date_after?: string;
  disposal_date_before?: string;
  ordering?: string;
}

const assetDisposalService = {
  // Get all disposal requests
  getDisposalRequests: (params?: DisposalRequestParams) => {
    return api.get('/assets/disposals/requests/detail/', { params });
  },
  
  // Get a specific disposal request
  getDisposalRequest: (id: string) => {
    console.log(`Fetching disposal request with ID: ${id}`);
    return api.get(`/assets/disposals/requests/${id}/`)
      .then(response => {
        console.log('Disposal request API response:', response);
        return response;
      })
      .catch(error => {
        console.error('Error fetching disposal request:', error);
        throw error;
      });
  },
  
  // Create a new disposal request
  createDisposalRequest: (formdata: FormData) => {
    return api.post('/assets/disposals/requests/', formdata);
  },
  
  // Update a disposal request
  updateDisposalRequest: (id: string, data: Partial<DisposalRequest>) => {
    return api.post(`/assets/disposals/requests/${id}/submit/`, data);
  },
  
  // Delete a disposal request
  deleteDisposalRequest: (id: string) => {
    return api.delete(`/assets/disposals/requests/${id}/`);
  },
  
  // Create a bulk disposal request
  createBulkDisposalRequest: (data: DisposalRequest) => {
    return api.post('/assets/disposals/bulk/', data);
  },
  
  // Get disposed assets
  getDisposedAssets: (params?: DisposalRequestParams) => {
    return api.get('/assets/disposals/disposed-assets/', { params });
  },
  
  // Upload disposal documents
  uploadDisposalDocuments: (id: string, formData: FormData) => {
    return apiFormData.post(`/assets/disposals/requests/${id}/`, formData);
  },
  
  // Get disposal documents
  getDisposalDocuments: (id: string) => {
    return api.get(`/assets/disposals/requests/${id}`);
  },

  // Approve a disposal request
  approveDisposalRequest: (id: string) => {
    return api.post(`/assets/disposals/requests/${id}/approve/`);
  },

  // Reject a disposal request
  rejectDisposalRequest: (id: string, reason: string) => {
    return api.post(`/assets/disposals/requests/${id}/reject/`, { reason });
  }
};

export default assetDisposalService;